import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { getFirebaseApp, getAnalyticsInstance } from "@lib/firebase";

export function App() {
  useEffect(() => {
    // Inicializar Firebase de forma perezosa al montar la app.
    getFirebaseApp();
    void getAnalyticsInstance();
  }, []);

  return (
    <RouterProvider
      router={router}
      future={{ v7_startTransition: true }}
    />
  );
}
